var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { withResizeObserver } from '../../internal/with-resize-observer.js';
import styles from './responsive-header.styles';
import '../../atoms/nav/sgdf-navbar.js';
import '@shoelace-style/shoelace/dist/components/avatar/avatar.js';
import '@shoelace-style/shoelace/dist/components/drawer/drawer.js';
import '../../atoms/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '../user-menu/sgdf-user-menu.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
let SgdfResponsiveHeader = class SgdfResponsiveHeader extends withResizeObserver(SgdfElement) {
    constructor() {
        super(...arguments);
        this.mode = 'normal';
        this.navItems = null;
        this.userMenus = null;
    }
    onResize({ width }) {
        this._width = width;
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateComplete.then(() => {
            this.drawer.addEventListener('click', () => this.drawer.hide());
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    render() {
        var _a, _b;
        const bigMode = this._width && this._width > 700;
        return html `<div
            class=${classMap({
            'big-container': bigMode && this.mode === 'normal',
        })}
        >
            <sl-drawer class="drawer-menu" label="Menu" placement="start">
                ${bigMode
            ? null
            : html `<slot class="drawer-navbar" name="navbar"></slot>`}
            </sl-drawer>

            <sl-drawer class="drawer-search" label="Rechercher" placement="end">
                <slot class="drawer-search" @sgdf-select-entity=${() => this.drawerSearch.hide()} name="search"></slot>
            </sl-drawer>

            <div
                class=${classMap({
            'big-container': bigMode && this.mode === 'normal',
        })}
            >
                ${bigMode && this.mode === 'normal'
            ? html `<div class="header">
                          <slot name="logo"></slot>
                          <div class="header-title">
                              <span>${this.title}</span>
                          </div>
                          <sgdf-user-menu
                              .username=${this.username}
                              .appRole=${(_a = this.role) !== null && _a !== void 0 ? _a : undefined}
                              .imageUrl=${this.imageUrl}
                          >
                              <slot name="user-menu" slot="menu"> </slot>
                          </sgdf-user-menu>
                      </div>`
            : null}
                <sgdf-navbar class="navbar">
                    ${bigMode && this.mode === 'compact' && html `<slot name="logo"></slot>`}
                    <slot></slot>
                    ${!bigMode || this.mode === 'compact'
            ? html `
                              <span slot="center" class="title"
                                  >${this.title}</span
                              >
                              <div class="right-buttons" slot="end">
                                  ${this.hasSearch && ((_b = this.appRole) === null || _b === void 0 ? void 0 : _b.isFormer)
                ? html ` <sgdf-icon
                                            class="clickable"
                                            name="magnifying-glass"
                                            style="--icon-size: 1.5em; color: white;"
                                            @click=${() => this.drawerSearch.show()}
                                        ></sgdf-icon>`
                : null}
                                  <sl-dropdown
                                      placement="bottom-end"
                                      distance="10"
                                  >
                                      <sl-avatar
                                          class="avatar"
                                          style="--size: 2em"
                                          slot="trigger"
                                          .imageUrl=${this.imageUrl}
                                      ></sl-avatar>
                                      <slot name="user-menu"> </slot>
                                  </sl-dropdown>
                              </div>
                          `
            : null}
                </sgdf-navbar>
            </div>
        </div> `;
    }
};
SgdfResponsiveHeader.styles = styles;
__decorate([
    property({ type: String, reflect: true })
], SgdfResponsiveHeader.prototype, "title", void 0);
__decorate([
    property()
], SgdfResponsiveHeader.prototype, "logoPath", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfResponsiveHeader.prototype, "username", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfResponsiveHeader.prototype, "appRole", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfResponsiveHeader.prototype, "imageUrl", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfResponsiveHeader.prototype, "hasSearch", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfResponsiveHeader.prototype, "mode", void 0);
__decorate([
    query('.drawer-menu')
], SgdfResponsiveHeader.prototype, "drawer", void 0);
__decorate([
    query('.drawer-search')
], SgdfResponsiveHeader.prototype, "drawerSearch", void 0);
__decorate([
    query('.menu')
], SgdfResponsiveHeader.prototype, "menu", void 0);
__decorate([
    query('slot')
], SgdfResponsiveHeader.prototype, "defaultSlot", void 0);
__decorate([
    state()
], SgdfResponsiveHeader.prototype, "navItems", void 0);
__decorate([
    state()
], SgdfResponsiveHeader.prototype, "userMenus", void 0);
SgdfResponsiveHeader = __decorate([
    customElement('sgdf-responsive-header')
], SgdfResponsiveHeader);
export default SgdfResponsiveHeader;
//# sourceMappingURL=responsive-header.js.map